import React from 'react';
import { Result } from '../../../types';
import Step4 from '../Step4';

interface ResultProps {
  result: Result | null;
}

const Step3Result: React.FC<ResultProps> = ({ result }) => {
  return result ? (
    <div className="recommendation font-large-text">
      <h2 className="title">{result.title}</h2>
      <div className="mb-16">{result.subTitle}</div>
      <h3>{result.option1Title}</h3>
      <div className="mb-16">{result.option1Description}</div>
      <h3>{result.option2Title}</h3>
      <div>{result.option2Description}</div>
      <div className="mt-16">{result.note}</div>
      <Step4 />
    </div>
  ) : null;
};
export default Step3Result;
